import { PickerService, GlobalPickerService, PickItemInterceptor, PickServiceInterceptor } from "./constants";

import { Canvas3DPickItemInterceptor, InteractivePickItemInterceptorContribution, ShadowPickServiceInterceptorContribution, ShadowRootPickItemInterceptorContribution } from "./pick-interceptor";

import { bindContributionProvider } from "../common/contribution-provider";

export function bindPickModules({bind: bind, isBound: isBound}) {
    isBound(PickerService) || (bind(GlobalPickerService).toSelf(), bind(PickerService).toService(GlobalPickerService)), 
    bind(Canvas3DPickItemInterceptor).toSelf().inSingletonScope(), bind(PickItemInterceptor).toService(Canvas3DPickItemInterceptor), 
    bind(ShadowRootPickItemInterceptorContribution).toSelf().inSingletonScope(), bind(PickItemInterceptor).toService(ShadowRootPickItemInterceptorContribution), 
    bind(InteractivePickItemInterceptorContribution).toSelf().inSingletonScope(), bind(PickItemInterceptor).toService(InteractivePickItemInterceptorContribution), 
    bindContributionProvider(bind, PickItemInterceptor), bind(ShadowPickServiceInterceptorContribution).toSelf().inSingletonScope(), 
    bind(PickServiceInterceptor).toService(ShadowPickServiceInterceptorContribution), 
    bindContributionProvider(bind, PickServiceInterceptor);
}

export default bindPickModules;
//# sourceMappingURL=pick-modules.js.map
